import React, { useState, useEffect } from 'react';
import '../../../Assets/Css/EmpAttendanceByHour.scss';
import Absent from "../../../Assets/Images/Attendance/absent.svg";
import Holiday from "../../../Assets/Images/Attendance/Holiday.svg";
import RightArrow from "../../../Assets/Images/Attendance/Right Arrow.svg";
import Leave from "../../../Assets/Images/Attendance/leave.svg";
import Halfday from "../../../Assets/Images/Attendance/half-day.svg";
import { Link } from 'react-router-dom';
import moment from 'moment';
import UserAvatar from 'react-user-avatar';
import { FaUserCircle } from 'react-icons/fa';

const statusMap = {
    'p': 'Present',
    'a': 'Absent',
    'la': 'Late',
    'hod': 'Holiday',
    'Sun': 'Holiday',
    'hd': 'Half Day',
    'ol': 'On Leave'
};
const EmpAttendanceByHour = (props) => {
    const [daysInMonth, setDaysInMonth] = useState([]);
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();
    const currentDate = moment();
    const userProfilePic = localStorage.getItem('userProfilePic');
    const [employeeData, setEmployeeData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(month);
    const [selectedYear, setSelectedYear] = useState(year);
    const selectEmp = props?.selectedUser
        ? props?.data?.users?.filter((user) => user?.id === props?.selectedUser?.id) || []
        : props?.data?.user?.role?.name?.includes('hr')
            ? props?.data?.users || []
            : props?.data?.users?.filter((user) => user?.id === props?.data?.user?.id) || [];

    useEffect(() => {
        if (!props?.data?.attendance || !props?.data?.leave || !props?.data?.users) return;

        const employeeAttendanceData = selectEmp.map(user => {
            const attendanceData = props?.data?.attendance?.filter((att) => att?.employee_id === user?.id) || [];
            const leaveData = props?.data?.leave?.filter((leave) => leave?.employee_id === user?.id) || [];

            const attendanceMap = {};
            attendanceData?.forEach(item => {
                const dateKey = moment(item?.date?.split(' ')[0]).format('YYYY-MM-DD');
                if (!attendanceMap[dateKey]) {
                    attendanceMap[dateKey] = [];
                }
                attendanceMap[dateKey].push(item);
            });

            const leaveMap = {};
            leaveData.forEach(leave => {
                if (leave.status === 'Approved') {
                    const startDate = moment(leave?.start_date).startOf('day');
                    const endDate = moment(leave?.end_date).startOf('day');

                    let currentDate = startDate.clone();
                    while (currentDate.isSameOrBefore(endDate, 'day')) {
                        const dateKey = currentDate.format('YYYY-MM-DD');
                        if (leaveMap[dateKey]) {
                            leaveMap[dateKey] = {
                                ...leaveMap[dateKey],
                                firstHalf: leaveMap[dateKey].firstHalf || leave.firstHalf,
                                secondHalf: leaveMap[dateKey].secondHalf || leave.secondHalf,
                                reason: leaveMap[dateKey].reason + (leave.reason !== leaveMap[dateKey].reason ? ` & ${leave.reason}` : ''),
                                casual: (parseFloat(leaveMap[dateKey].casual || 0) + parseFloat(leave.casual || 0)).toString(),
                                unpaid: (parseFloat(leaveMap[dateKey].unpaid || 0) + parseFloat(leave.unpaid || 0)).toString()
                            };
                        } else {
                            leaveMap[dateKey] = { ...leave };
                        }
                        currentDate.add(1, 'day');
                    }
                }
            });

            const attendance = {};
            attendance[year] = {};

            for (let m = 1; m <= 12; m++) {
                const daysInMonth = moment(`${year}-${m}`, 'YYYY-M').daysInMonth();
                attendance[year][m] = [];

                for (let day = 1; day <= daysInMonth; day++) {
                    const date = moment(`${year}-${m}-${day}`, 'YYYY-M-D');
                    const dateKey = date.format('YYYY-MM-DD');

                    const punch = attendanceMap[dateKey];
                    const leave = leaveMap[dateKey];

                    let status = '-';
                    let hours = 0;

                    if (date.isAfter(currentDate, 'day')) {
                        if (leave?.firstHalf && leave?.secondHalf) {
                            status = 'ol';
                            hours = 0;
                        } else if (leave?.firstHalf || leave?.secondHalf) {
                            status = 'hd';
                            hours = 4;
                        } else if (date.format('ddd') === 'Sun') {
                            status = 'Sun';
                            hours = 0;
                        } else {
                            status = '-';
                            hours = 0;
                        }
                    } else if (date.format('ddd') === 'Sun') {
                        status = 'Sun';
                        hours = 0;
                    } else if (leave?.firstHalf && leave?.secondHalf) {
                        status = 'ol';
                        hours = 0;
                    } else if (leave?.firstHalf || leave?.secondHalf) {
                        if (Array.isArray(punch)) {
                            let totalMinutes = 0;
                            let earliestClockIn = null;

                            punch.forEach(entry => {
                                if (entry.clock_in) {
                                    const clockIn = moment(entry.clock_in, 'HH:mm');
                                    let clockOut = entry.clock_out ? moment(entry.clock_out, 'HH:mm') : moment(entry.date, 'HH:mm:ss').endOf('day');
                                    const diff = moment.duration(clockOut.diff(clockIn)).asMinutes();
                                    totalMinutes += diff;

                                    if (!earliestClockIn || clockIn.isBefore(earliestClockIn)) {
                                        earliestClockIn = clockIn;
                                    }
                                }
                            });

                            const hrs = Math.floor(totalMinutes / 60);
                            const mins = Math.floor(totalMinutes % 60);
                            hours = `${hrs}:${mins.toString().padStart(2, '0')}`;
                            status = 'hd';
                        } else if (punch?.clock_in) {
                            const clockInTime = moment(punch.clock_in, 'HH:mm');
                            let clockOutTime;

                            if (punch.clock_out) {
                                clockOutTime = moment(punch.clock_out, 'HH:mm');
                            } else {
                                if (date.isSame(moment(), 'day')) {
                                    clockOutTime = moment();
                                } else {
                                    clockOutTime = moment(punch.date, 'HH:mm:ss').endOf('day');
                                }
                            }

                            const diff = moment.duration(clockOutTime.diff(clockInTime));
                            const totalMinutes = diff.asMinutes();
                            const hrs = Math.floor(totalMinutes / 60);
                            const mins = Math.floor(totalMinutes % 60);
                            hours = `${hrs}:${mins.toString().padStart(2, '0')}`;
                            status = 'hd';
                        } else {
                            status = 'hd';
                            hours = 0;
                        }
                    } else if (Array.isArray(punch)) {
                        let totalMinutes = 0;
                        let earliestClockIn = null;

                        punch.forEach(entry => {
                            if (entry.clock_in) {
                                let clockOut;
                                const clockIn = moment(entry.clock_in, 'HH:mm');
                                if (date.isSame(moment(), 'day') && !entry.clock_out) {
                                    clockOut = moment();
                                } else {
                                    clockOut = entry.clock_out ? moment(entry.clock_out, 'HH:mm') : moment(entry.date, 'HH:mm:ss').endOf('day');
                                }
                                const diff = moment.duration(clockOut.diff(clockIn)).asMinutes();
                                totalMinutes += diff;

                                if (!earliestClockIn || clockIn.isBefore(earliestClockIn)) {
                                    earliestClockIn = clockIn;
                                }
                            }
                        });

                        const hrs = Math.floor(totalMinutes / 60);
                        const mins = Math.floor(totalMinutes % 60);
                        hours = `${hrs}:${mins.toString().padStart(2, '0')}`;
                        const lateTime = moment('11:00', 'HH:mm');
                        status = earliestClockIn?.isAfter(lateTime) ? 'la' : 'p';
                    } else if (punch?.clock_in) {
                        const clockInTime = moment(punch.clock_in, 'HH:mm');
                        let clockOutTime;

                        if (punch.clock_out) {
                            clockOutTime = moment(punch.clock_out, 'HH:mm');
                        } else {
                            if (date.isSame(moment(), 'day')) {
                                clockOutTime = moment();
                            } else {
                                clockOutTime = moment(punch.date, 'HH:mm:ss').endOf('day');
                            }
                        }

                        const diff = moment.duration(clockOutTime.diff(clockInTime));
                        const totalMinutes = diff.asMinutes();
                        const hrs = Math.floor(totalMinutes / 60);
                        const mins = Math.floor(totalMinutes % 60);
                        hours = `${hrs}:${mins.toString().padStart(2, '0')}`;
                        const lateTime = moment('11:00', 'HH:mm');
                        status = clockInTime.isAfter(lateTime) ? 'la' : 'p';
                    } else {
                        status = 'a';
                        hours = 0;
                    }

                    attendance[year][m].push({
                        day: date.format('ddd'),
                        status,
                        hours
                    });
                }
            }

            return {
                name: user.name,
                role: user.designation?.name || user.role?.name || '',
                avatar: user.profile_pic || userProfilePic || '',
                attendance
            };
        });

        setEmployeeData(employeeAttendanceData);
    }, [props, selectEmp]);

    useEffect(() => {
        try {
            let tempMonth = selectedMonth;
            let tempYear = selectedYear;

            if (!props?.selectFilters?.Month?.value && !props?.selectFilters?.Year?.value && !props?.selectFilters?.Late?.value) {
                setFilteredData([]);
                const days = calculateDaysInMonth(month, year);
                const daysArray = Array.from({ length: days }, (_, index) => {
                    const date = new Date(year, month - 1, index + 1);
                    return { day: index + 1, dayName: date.toLocaleDateString('en-US', { weekday: 'short' }) };
                });
                setDaysInMonth(daysArray);
                return;
            }

            if (props?.selectFilters?.Month?.value) {
                tempMonth = new Date(`${props.selectFilters.Month.value} 1,${selectedYear}`).getMonth() + 1;
            }
            if (props?.selectFilters?.Year?.value) {
                tempYear = parseInt(props.selectFilters.Year.value);
            }

            setSelectedMonth(tempMonth);
            setSelectedYear(tempYear);

            const days = calculateDaysInMonth(tempMonth, tempYear);
            const daysArray = Array.from({ length: days }, (_, index) => {
                const date = new Date(tempYear, tempMonth - 1, index + 1);
                return { day: index + 1, dayName: date.toLocaleDateString('en-US', { weekday: 'short' }) };
            });

            setDaysInMonth(daysArray);

            const filteredEmployeeData = employeeData.map(employee => {
                let selectedData = employee?.attendance?.[tempYear]?.[tempMonth] || [];
                if (props?.selectFilters?.Late?.value) {
                    selectedData = selectedData.map(item => ({
                        ...item,
                        status: statusMap[item?.status] === props?.selectFilters?.Late?.value ? item?.status : ''
                    }));
                }
                return {
                    ...employee,
                    attendance: {
                        [tempYear]: {
                            [tempMonth]: selectedData
                        }
                    }
                };
            });

            setFilteredData(filteredEmployeeData);
        } catch (error) {
            console.error("Error in filtered useEffect: ", error);
        }
    }, [props, employeeData]);

    const calculateDaysInMonth = (month, year) => {
        return new Date(year, month, 0).getDate();
    };

    return (
        <div className="attendance-table">
            <div className="suggestion">
                <h6 className='m-0 me-2 '>Note :</h6>
                <div className='suggestion_comp'>
                    <img src={Holiday} className='svg' />
                    <img src={RightArrow} className='svgarrow' />
                    Holiday
                </div>
                <div className='suggestion_comp'>
                    <img src={Halfday} className='svg' />
                    <img src={RightArrow} className='svgarrow' />
                    Half Day
                </div>
                <div className='suggestion_comp'>
                    <img src={Absent} className='svg' />
                    <img src={RightArrow} className='svgarrow' />
                    Absent
                </div>
                <div className='suggestion_comp'>
                    <img src={Leave} className='svg' />
                    <img src={RightArrow} className='svgarrow' />
                    On leave
                </div>
            </div>

            <div className='table_cont'>
                <table>
                    <thead>
                        <tr>
                            <th className='firsttablehead'>Employee</th>
                            {daysInMonth.map((item, idx) => (
                                <th key={idx} className=''>{item.day}</th>
                            ))}
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(filteredData?.length > 0 ? filteredData : employeeData)?.map((employee, idx) => {
                            const attendanceForMonth = employee?.attendance?.[!props?.selectFilters?.Month?.value && !props?.selectFilters?.Year?.value && !props?.selectFilters?.Late?.value ? year : selectedYear]?.[!props?.selectFilters?.Month?.value && !props?.selectFilters?.Year?.value && !props?.selectFilters?.Late?.value ? month : selectedMonth] || [];
                            return (
                                <tr key={idx}>
                                    <td className="employee-info">
                                        {employee?.avatar ? (
                                            <img src={employee.avatar} alt={employee.name} />
                                        ) : (
                                                employee?.name && <UserAvatar name={employee?.name || ""} size={40} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                                        )}
                                        <div className='employee-info-details'>
                                            <span>{employee.name}</span>
                                            <span className="role">{employee.role}</span>
                                        </div>
                                    </td>
                                    {attendanceForMonth.map((item, idx) => (
                                        <td key={idx}>
                                            <Link to={(item?.status === "Sun" || item?.status === 'hod' || item?.status === 'ol' || item?.status === 'a') ? "#" : '/attendance/empdetails'}
                                                state={{
                                                    dayDetails: {
                                                        date: `${selectedYear || year}-${String(selectedMonth || month).padStart(2, '0')}-${String(idx + 1).padStart(2, '0')}`,
                                                        records: props?.data?.attendance?.filter(att =>
                                                            moment(att.date?.split(' ')[0]).format('YYYY-MM-DD') ===
                                                            `${selectedYear || year}-${String(selectedMonth || month).padStart(2, '0')}-${String(idx + 1).padStart(2, '0')}` &&
                                                            att.employee_id === employee.id
                                                        )
                                                    }
                                                }} className="attendance-link">
                                                {
                                                    (() => {
                                                        switch (item.status) {
                                                            case "Sun": return (
                                                                <div className="sh-img">
                                                                    <img src={Holiday} className='svg_table' />
                                                                    <div className="tooltip">Sunday</div>
                                                                </div>
                                                            );
                                                            case "hod": return <img src={Holiday} className='svg_table' />;
                                                            case "ol": return <img src={Leave} className='svg_table' />;
                                                            case "a": return <img src={Absent} className='svg_table' />;
                                                            case "hd": return <img src={Halfday} className='svg_table' />;
                                                            case "-": return <span style={{ fontWeight: 'normal' }}>-</span>;
                                                            default: return (item.hours !== 0 ? item.hours : <img src={Absent} className='svg_table' />);
                                                        }
                                                    })()
                                                }
                                            </Link>
                                        </td>
                                    ))}
                                    <td className="total">
                                        {(() => {
                                            let totalMinutes = 0;

                                            attendanceForMonth.forEach(item => {
                                                if (typeof item.hours === 'string' && item.hours.includes(':')) {
                                                    const [hrs, mins] = item.hours.split(':').map(Number);
                                                    totalMinutes += hrs * 60 + mins;
                                                } else if (!isNaN(item.hours)) {
                                                    totalMinutes += Number(item.hours) * 60;
                                                }
                                            });

                                            const hrs = Math.floor(totalMinutes / 60);
                                            const mins = totalMinutes % 60;
                                            return `${hrs}h ${mins.toString().padStart(2, '0')}m`;
                                        })()}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EmpAttendanceByHour;